<template>
  <b-container>
    <b-card border-variant="danger" :header="$t('ForgotPassword.header')" header-bg-variant="danger" header-text-variant="white" align="left">
      <b-form @submit="onSubmit" autocomplete="off">
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('ForgotPassword.emailPlaceholder')" v-model="email" type="email"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button variant="danger" type="submit">{{ $t('ForgotPassword.getTempPassword') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
          <b-alert :show="success.received" variant="success" class="text-center">{{success.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import ForgotPasswordService from '@/services/ForgotPasswordService'
import HelperFunctions from '@/extras/HelperFunctions'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      email: '',
      error: {
        received: false,
        msg: ''
      },
      success: {
        received: false,
        msg: ''
      }
    }
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.findUserAndCreateTempPassword()
    },
    async findUserAndCreateTempPassword () {
      const tempPassword = HelperFunctions.randomString()
      try {
        await ForgotPasswordService.setTempPassword({ email: this.email, password: tempPassword, resetPassword: true })

        this.emailTempPassword(tempPassword)
      } catch (error) {
        this.error.received = true
        if (error.response.data.error === 'userNotFound') {
          this.error.msg = this.$i18n.t('ForgotPassword.serverMessages.userNotFound')
        } else {
          this.error.msg = error.response.data.error
        }
      }
    },
    async emailTempPassword (tempPassword) {
      try {
        await ForgotPasswordService.emailTempPassword({ email: this.email, password: tempPassword })

        // clear out form
        this.email = ''

        // print success message
        this.success.received = true
        this.success.msg = this.$i18n.t('ForgotPassword.serverMessages.tempPasswordEmailSent')
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue